import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';
import ErrorLayout from './ErrorLayout';
import HelpfulLinks from './HelpfulLinks';
import { useFallbackLayout } from '@fhnw/hooks/useFallbackLayout';

const NotFound: React.FC = () => {
  useFallbackLayout();

  return (
    <ErrorLayout
      title={
        <FormattedMessage
          id="error.404.title"
          defaultMessage="This page does not seem to exist."
        />
      }
    >
      <p className="documentDescription">
        <FormattedMessage
          id="error.404.lead"
          defaultMessage="We apologize for the inconvenience, but the page you were trying to access is not at this address. You can use the links below to help you find what you are looking for."
        />
      </p>

      <HelpfulLinks />
    </ErrorLayout>
  );
};

// Important: force HTTP status 404 (also for SEO)
export default withServerErrorCode(404)(NotFound);
